import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import AuthShell, { Field } from "./AuthShell";
import { api, errMsg } from "../lib/api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [form, setForm] = useState({ password: "", confirm: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (form.password !== form.confirm) return setError("Passwords don't match");
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password: form.password });
      toast.success("Password updated — please log in with your new password");
      navigate("/login");
    } catch (err) {
      setError(errMsg(err));
      setLoading(false);
    }
  };

  return (
    <AuthShell title="Choose a new password" subtitle="Pick something at least 6 characters long."
      footer={<>Link expired? <Link to="/forgot-password" className="font-semibold text-[#2F5D4A] hover:underline" data-testid="reset-request-new-link">Request a new one</Link></>}>
      {!token ? (
        <p className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-xl px-3 py-2" data-testid="reset-missing-token">This reset link is missing its token. Please request a new one.</p>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="reset-password-form">
          <Field label="New password" type="password" required minLength={6} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="reset-password-input" autoComplete="new-password" />
          <Field label="Confirm new password" type="password" required minLength={6} value={form.confirm} onChange={(e) => setForm({ ...form, confirm: e.target.value })} data-testid="reset-confirm-input" autoComplete="new-password" />
          {error && <p className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-xl px-3 py-2" data-testid="reset-error">{error}</p>}
          <button type="submit" disabled={loading} className="btn-primary w-full justify-center !py-3" data-testid="reset-submit-button">
            {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : "Update password"}
          </button>
        </form>
      )}
    </AuthShell>
  );
}
